<template>
  <div>
    <div class="search-results-header">
      <div class="search-results-type">
        <transition name="search-results-type-inner">
          <div v-bind:key="typeLabel">
            {{ typeLabel }}
          </div>
        </transition>
      </div>
      <div class="search-results-count">
        <global-search-number :number="results.length"></global-search-number>
        {{ results.length > 1 ? 'results' : 'result' }}
      </div>
    </div>
    <transition name="search-results-reveal">
      <div v-if="show">
        <component
          :is="getComponent(result)"
          v-for="(result, index) in results"
          :key="index"
          :result="result"
        >
        </component>
      </div>
    </transition>
  </div>
</template>

<script>
import GlobalSearchNumber from '@/components/search/GlobalSearchNumber'
import GlobalSearchResult from '@/components/search/GlobalSearchResult'
import GlobalSearchExternalResult from '@/components/search/GlobalSearchExternalResult'
import GlobalSearchStartupResult from '@/components/search/GlobalSearchStartupResult'

export default {
  components: {
    GlobalSearchNumber,
    GlobalSearchResult,
    GlobalSearchExternalResult,
    GlobalSearchStartupResult
  },
  props: {
    results: Array,
    type: Object
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    typeLabel() {
      return this.type ? this.type.label : 'All results'
    }
  },
  mounted() {
    this.show = true
  },
  methods: {
    getComponent(result) {
      if (result.type === 'startup_import') {
        return 'global-search-startup-result'
      } else if (result.field_no_detail === '1') {
        return 'global-search-external-result'
      } else {
        return 'global-search-result'
      }
    }
  },
  watch: {
    results() {
      this.show = false

      setTimeout(() => {
        this.show = true
      }, 200)
    }
  }
}
</script>
